import axios from 'axios';
import config from '../config';

export const request = async () => axios({
  method: 'post',
  url: `${config.wssApiUrl}/token`,
  headers: {
    'X-API-KEY': config.wssApiKey,
    'X-CLIENT-NAME': (window.userInfo || {}).username || 'hippo',
  },
})
  .then((resp) => resp.data);

export default { request };
